import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TypeofcollegeRoutingModule } from './typeofcollege-routing.module';
import { TypeofcollegeListComponent } from './typeofcollege-list/typeofcollege-list.component';
import { TypeofcollegeCreateComponent } from './typeofcollege-create/typeofcollege-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [TypeofcollegeListComponent, TypeofcollegeCreateComponent],
  imports: [
    CommonModule,
    TypeofcollegeRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class TypeofcollegeModule { }
